module.exports = __webpack_public_path__ + "img/stripe_logo.344eea74.svg";